import { Navigate } from 'react-router-dom';

import { CSAT_DASHBOARD_PATH } from './core/customerSatisfactionRoutes';

export function CustomerSatisfactionIndexRedirect() {
  return <Navigate to={CSAT_DASHBOARD_PATH} replace />;
}
